import { render, staticRenderFns } from "./alteracao-de-status.vue?vue&type=template&id=81d96ab6"
import script from "./alteracao-de-status.vue?vue&type=script&lang=js"
export * from "./alteracao-de-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports